export var PusherEvent;
(function (PusherEvent) {
    PusherEvent["Connected"] = "connected";
    PusherEvent["Disconnected"] = "disconnected";
    PusherEvent["Unavailable"] = "unavailable";
    PusherEvent["Error"] = "error";
    PusherEvent["ChatCreated"] = "chat:created";
    PusherEvent["ChatUpdated"] = "chat:updated";
    PusherEvent["ChatMembershipsCreated"] = "chatMemberships:created";
    PusherEvent["ChatMembershipDeactivated"] = "chatMembership:deactivated";
    PusherEvent["ChatMembershipStateUpdated"] = "chatMembershipState:updated";
    PusherEvent["MessageCreated"] = "message:created";
    PusherEvent["MessageUpdated"] = "message:updated";
    PusherEvent["MessageDeleted"] = "message:deleted";
    PusherEvent["ReactMessageCreated"] = "reactMessage:created";
    PusherEvent["ReactMessageRemoved"] = "reactMessage:removed";
    PusherEvent["TypingStarted"] = "typing:started";
    PusherEvent["TypingStopped"] = "typing:stopped";
    PusherEvent["ReceiptUpdate"] = "receipt:update";
    PusherEvent["AgentUpdated"] = "agent:updated";
    PusherEvent["AgentCreated"] = "agent:created";
    PusherEvent["AgentDeleted"] = "agent:deleted";
    PusherEvent["OAuthUpdated"] = "oauth:updated";
    PusherEvent["OAuthTokenStale"] = "oauth:token:stale";
    PusherEvent["IntegrationRestrictionChanged"] = "integration:restriction:changed";
    PusherEvent["ReasoningUpdate"] = "reasoning:update";
    PusherEvent["ReasoningComplete"] = "reasoning:complete";
    PusherEvent["FeatureUsageUpdated"] = "featureUsage:updated";
    PusherEvent["SubscriptionUpdated"] = "subscription:updated";
    PusherEvent["CreditBalanceUpdated"] = "credit:balance:updated";
    PusherEvent["DocCreated"] = "doc:created";
    PusherEvent["DocUpdated"] = "doc:updated";
    PusherEvent["CreativeContentUpdated"] = "creative:content:updated";
    PusherEvent["CreativeMessageCreated"] = "creative:message:created";
    PusherEvent["CreativeTypingStarted"] = "creative:typing:started";
    PusherEvent["CreativeTypingThought"] = "creative:typing:thought";
    PusherEvent["CreativeTypingEnded"] = "creative:typing:ended";
    PusherEvent["CreativeVideoProgress"] = "creative:video:progress";
    PusherEvent["CreativeGenerationComplete"] = "creative:generation:complete";
    PusherEvent["CreativeScoreUpdated"] = "creative:score:updated";
    PusherEvent["CreativeGenerationPhase"] = "creative:generation:phase";
    PusherEvent["CreativePublishStarted"] = "creative:publish:started";
    PusherEvent["CreativePublishComplete"] = "creative:publish:complete";
    PusherEvent["SuggestionReady"] = "suggestion:ready";
    PusherEvent["SuggestionsComplete"] = "suggestions:complete";
    PusherEvent["PostSuggestionReady"] = "post:suggestion:ready";
    PusherEvent["PostSuggestionsComplete"] = "post:suggestions:complete";
    PusherEvent["PostReady"] = "post:ready";
    PusherEvent["PostTopicComplete"] = "post:topic:complete";
    PusherEvent["TopicReady"] = "topic:ready";
    PusherEvent["TopicCreativesReady"] = "topic:creatives:ready";
    PusherEvent["AutopilotCreativeReady"] = "autopilot:creative:ready";
    PusherEvent["AutopilotGenerationComplete"] = "autopilot:generation:complete";
    PusherEvent["ReferralRewardApproved"] = "referral:reward:approved";
    PusherEvent["BrandLearningCompleted"] = "brand-learning-completed";
})(PusherEvent || (PusherEvent = {}));
//# sourceMappingURL=pusher-event.const.js.map